import React from 'react';
import Hero from '../component/home/Hero';
import SlightestMe from '../component/home/SlightestMe';
import Skills from '../component/home/Skills';
import Project from '../component/home/Project';
import Offer from '../component/home/Offer';

function HomePage() {
  return (
    <main>
      <Hero />
      <SlightestMe />
      <Skills />
      <Project />
      <Offer />
    </main>
  );
}

export default HomePage;
